import React, {Component} from 'react';
import AsyncSelect from "react-select/async";
import apiUser from "../../../apiUser";
import PropTypes from "prop-types";
import {isNull} from "lodash";
import ClientAddModal from "../ClientAddModal/ClientAddModal";
import CreatableSelect from "react-select/async-creatable";
import apiPlatform from "../../../apiPlatform";
import {Badge} from "reactstrap";
import {withTranslation} from "react-i18next";
import workerHasPrivilege from "../../../utils/workerHasPrivilege";
import isWorker from "../../../utils/isWorker";

class ClientSelect extends Component {
  constructor(props) {
    super(props);

    this.selectRef = React.createRef();

    this.state = {
      focused: false,
      searchTimeout: false,
      defaultOptions: [],
      defaultValues: [],
      loading: false,
      search: '',
      options: [],
      value: props.value && this.getValueName(props.value),
      modalAdd: false,
      dataInitial: null,
    };

    this.fetchData = this.fetchData.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
  }

  componentDidMount() {
    if(this.props.client){
      this.setClientById(this.props.client)
    }
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if(this.props.client !== prevProps.client && this.props.client){
      this.setClientById(this.props.client)
    }
    if(this.props.value !== prevProps.value){
      this.setState({
        value: this.props.value ? this.getValueName(this.props.value) : null,
      })
    }
  }

  getValueName = value => ({
    label: <i className="text-info">{value}</i>,
    value: value,
  })

  setClientById(clientId){
    if(!workerHasPrivilege('clients.view')){
      return
    }

    apiUser.clients.get(clientId)
    .then(res => {
      this.setState({
        value: {
          value: clientId,
          label: this.getClientLabelSelected(res.data)
        }
      })
    });
  }

  handleOnFocus = () => {
    this.setState({
      focused: true,
      search: !this.props.client ? this.state.value?.value : '',
    })
    if(this.state.defaultOptions.length === 0){
      this.fetchData(
        '',
          options => this.setState({defaultOptions: options}),
          clients => this.setState({defaultValues: clients}),
      )
    }
  }

  fetchData(search, callback, handlerData){
    this.setState({
      loading: true,
    })
    clearTimeout(this.state.searchTimeout);
    this.setState({
      searchTimeout: setTimeout(() => {
        apiPlatform.clients.list(`order[id]=desc&q=${search}`)
        .then(res => {
          let options = res.data['hydra:member'].map(client => {
            return {
              value: client.id,
              label: this.getClientLabel(client),
            }
          });

          if(this.props.allowCreate) {
            options.unshift({
              value: null,
              label: (
                <div className="d-flex justify-content-center align-items-center mb-0 text-primary py-1">
                  <i className="fas fa-user-plus fa-2x"/>
                  <span className="ml-2">{this.props.t('btn_create')}</span>
                </div>
              )
            })
          }

          this.setState({
            data: res.data['hydra:member'],
            loading: false,
          }, () => {
            callback(options);
            handlerData && handlerData(res.data['hydra:member']);
          });
        }).catch(() => {
          this.setState({
            loading: false,
          })
        })
      }, 450)
    });
  }

  getClientLabel(client){
    let label;

    switch (client.type) {
      case 'person': {
        label = <div className="d-flex align-items-center">
          <i className="fas fa-address-book mr-2" />

          <div className="d-flex flex-column">
            <span>{client.firstname} {client.lastname}</span>
            {client.email && <span>{client.email}</span>}
            {client.phone && <span>{client.phone}</span>}
          </div>
        </div>;
        break;
      }
      case 'company': {
        label = <div className="d-flex align-items-center">
          <i className="fas fa-address-book mr-2" />

          <div className="d-flex flex-column">
            <span>{client.name}</span>
            <span>NIP: {client.nip}</span>
          </div>
        </div>;
        break;
      }
      default:
        label = <i>{this.props.t('common:no_data')}</i>;
    }

    return label;
  }

  getClientLabelSelected(client){
    let label;

    switch (client.type) {
      case 'person': {
        label = <span><i className="fas fa-address-book mr-2" /> <span>{client.firstname} {client.lastname}</span></span>;
        break;
      }
      case 'company': {
        label = <span><i className="fas fa-address-book mr-2" /> <span>{client.name} (NIP: {client.nip})</span></span>;
        break;
      }
      default: {
        label = <i>{this.props.t('common:no_data')}</i>;
      }
    }

    return label;
  }

  handleInputChange(search){
    this.setState({ search });
    return search;
  }

  render() {
    const {value, data, modalAdd, defaultOptions, defaultValues, loading} = this.state;

    let styles = {};
    if(this.props.documentAsTarget){
      styles.menu = (menu) => ({
        ...menu,
        maxWidth: '95vw',
        width: '250px',
      })
      styles.menuPortal = base => ({
        ...base,
        zIndex: 9999,
      });
    }

    let SelectComponent = AsyncSelect;
    let defaultProps = {
      classNamePrefix: "react-select",
      styles,
      menuPortalTarget: this.props.documentAsTarget ? document.body : undefined,
      isLoading: loading,
      defaultOptions: defaultOptions,
      className: `${this.props.className}`,
      onBlur: e => {
        this.props.onBlur && this.props.onBlur(e);
        this.setState({
          focused: false,
        })
      },
      onFocus: this.handleOnFocus,
      ref: this.selectRef,
      autoFocus: this.props.autoFocus,
      isClearable: this.props.isClearable,
      isDisabled: (isWorker() && !workerHasPrivilege('clients.view')) ? true : this.props.isDisabled,
      placeholder: this.props.placeholder ?? this.props.t('placeholder'),
      loadingMessage: () => <span>{this.props.t('common:search_in_progress')} <i className="fas fa-spin fa-spinner ml-2" /></span>,
      noOptionsMessage: () => <span><i className="fa fa-address-book" /> <span className="ml-2">{this.props.t('no_options')}</span></span>,
      loadOptions: this.fetchData,
      onInputChange: this.handleInputChange,
      value: value,
      inputValue: this.state.focused ? this.state.search : undefined,
      onChange: option => {
        if(isNull(option)){
          this.setState({
            value: null
          });

          this.props.onChange(null);
        }else if(isNull(option.value)){
          this.setState({
            value: null,
            modalAdd: true,
            dataInitial: null
          });
        }else{
          const client = data.find(c => c.id === option.value) ?? defaultValues.find(c => c.id === option.value);

          if(client){
            this.setState({
              value: {
                value: client.id,
                label: this.getClientLabelSelected(client),
              }
            });

            this.props.onChange(client);
          }else{
            if(!this.props.requireClient){
              this.setState({
                value: this.getValueName(option.value)
              });

              this.props.onChange(option.value);
            }
          }
        }
      },
    }

    if(!this.props.requireClient){
      SelectComponent = CreatableSelect;

      defaultProps.createOptionPosition = 'first';
      defaultProps.formatCreateLabel = (value) => <div className="text-center"><Badge color="info"><i>{value}</i></Badge></div>;
    }


    return <React.Fragment>
      <SelectComponent
        {...defaultProps}
      />
      {modalAdd && <ClientAddModal
        onModalClose={() => this.setState({modalAdd: false})}
        dataInitial={this.state.dataInitial ?? undefined}
        onAdded={client => {
          this.setState({
            modalAdd: false,
            value: {
              value: client.id,
              label: this.getClientLabelSelected(client),
            }
          });
          this.props.onChange(client);
        }}
      />}
    </React.Fragment>
  }
}

ClientSelect.defaultProps = {
  autoFocus: false,
  className: '',
  isClearable: true,
  isDisabled: false,
  requireClient: true,
  allowCreate: true,
};

ClientSelect.propTypes = {
  allowCreate: PropTypes.bool,
  autoFocus: PropTypes.bool,
  requireClient: PropTypes.bool,
  placeholder: PropTypes.string,
  isClearable: PropTypes.bool,
  isDisabled: PropTypes.bool,
  onChange: PropTypes.func,
  client: PropTypes.number,
  className: PropTypes.string,
};

export default withTranslation('client_select', {withRef: true})(ClientSelect);
